// components/MpesaTransactionList.jsx
import React, { useEffect, useState, useCallback } from 'react';
import { Table, Tag, Select, Space } from 'antd';
import { fetchMpesaTransactions } from '../api';

const { Option } = Select;

const STATUS_COLORS = {
    success: 'green',
    pending: 'orange',
    failed: 'red',
    cancelled: 'gold'
};

const MpesaTransactionList = ({ farmId, refreshKey }) => {
    const [transactions, setTransactions] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState(undefined);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const res = await fetchMpesaTransactions(farmId, {
                page: pagination.current,
                limit: pagination.pageSize,
                status: statusFilter
            });
            setTransactions(res.data);
            setTotal(res.total);
        } catch (err) {
            console.error('Error loading mpesa transactions:', err);
        } finally {
            setLoading(false);
        }
    }, [farmId, pagination.current, pagination.pageSize, statusFilter]);

    useEffect(() => { load(); }, [load, refreshKey]);

    const columns = [
        { title: 'Date', dataIndex: 'created_at', render: (v) => new Date(v).toLocaleString() },
        { title: 'Phone', dataIndex: 'phone' },
        { title: 'Amount (KES)', dataIndex: 'amount', render: (v) => Number(v).toLocaleString() },
        { title: 'Receipt No.', dataIndex: 'mpesa_receipt', render: (v) => v || '—' },
        {
            title: 'Status',
            dataIndex: 'status',
            render: (status) => <Tag color={STATUS_COLORS[status] || 'default'}>{status.toUpperCase()}</Tag>
        },
        { title: 'Description', dataIndex: 'result_desc', render: (v) => v || '—' }
    ];

    return (
        <>
            <Space style={{ marginBottom: 16 }}>
                <Select
                    placeholder="Filter by status"
                    allowClear
                    style={{ width: 180 }}
                    value={statusFilter}
                    onChange={(val) => {
                        setStatusFilter(val);
                        setPagination((p) => ({ ...p, current: 1 }));
                    }}
                >
                    <Option value="success">Success</Option>
                    <Option value="pending">Pending</Option>
                    <Option value="failed">Failed</Option>
                    <Option value="cancelled">Cancelled</Option>
                </Select>
            </Space>
            <Table
                rowKey="id"
                columns={columns}
                dataSource={transactions}
                loading={loading}
                pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total,
                    onChange: (page, pageSize) => setPagination({ current: page, pageSize })
                }}
            />
        </>
    );
};

export default MpesaTransactionList;